import { Component, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { Client } from 'src/app/interfaces/client';
import { RestService } from 'src/app/services/rest/rest.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage/storage.service';

declare var google;

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.page.html',
  styleUrls: ['./clientes.page.scss'],
})
export class ClientesPage implements OnInit {
  name: string;
  dni: string;
  userRole: any;
  currentPage = 0;
  maxPage = 0;
  limit = 50;

  columns = [
    {
      field: 'id',
      name: 'id',
      width: 5
    },
    {
      field: 'nombre',
      name: 'nombre',
      width: 20
    },
    {
      field: 'documento',
      name: 'CIF',
      width: 10
    },
    {
      field: 'correo',
      name: 'email',
      width: 15
    },
    {
      field: 'dfiscal',
      name: 'dirección',
      width: 20
    },
    {
      field: 'action',
      name: 'acciones rápidas',
      width: 20,
      actions: [
        {
          type: 'delete'
        },
        {
          type: 'edit'
        },
        {
          type: 'call',
          validate: 'contact'
        },
        {
          type: 'location',
          validate: 'address'
        }
      ]
    }
  ];

  lines: Client[];
  searchMode = false;

  constructor(private alert: AlertController,
    private rest: RestService,
    private utils: UtilsService,
    private router: Router,
    private storage: StorageService
  ) { }

  async ionViewWillEnter() {
    await this.utils.showLoading();
    this.getUserInfo();
    this.getClients();
    console.log(this.lines);
    await this.utils.hideLoading();
  }

  ngOnInit() { }

  async getUserInfo() {
    const result = await this.storage.getUser();
    this.userRole = result.role;
  }

  async getClients() {
    this.searchMode = false;
    const resp = await this.rest.getClients(this.currentPage + 1, this.limit);
    console.log(resp);
    
    this.maxPage = Math.ceil((resp.body.total / this.limit) + ((resp.body.total % this.limit > 0) ? 1 : 0));
    this.lines = resp.body.records;
  }

  
  async search() {
    this.searchMode = true;
    try {
      await this.utils.showLoading();
      console.log('Search this');
      let resp;
      if (!this.name && !this.dni) {
        resp = await this.rest.getClients();
        this.maxPage = Math.ceil((resp.body.total / 50) + ((resp.body.total % 50 > 0) ? 1 : 0));
      } else {
        resp = await this.rest.getClientsByNameDocument(this.currentPage + 1, 50, this.name, this.dni);
        console.log(resp)
        this.maxPage = Math.ceil((resp.body.total / 50) + ((resp.body.total % 50 > 0) ? 1 : 0));
      }
      console.log(resp);
      this.lines = resp.body.records;
      await this.utils.hideLoading();
    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
      await this.utils.showToast('Error cargando clientes', 'danger', 3000);
    }
    // this.currentPage = 0;
  }

  
  

  async doAction(data) {
    console.log(data);
    const line: Client = data.line;
    if (data.action === 'delete') {
      this.deleteItem(line.id, line._id);
    }
    if (data.action === 'edit') {
      this.router.navigateByUrl(`/cliente/${line._id}`);
    }
    if (data.action === 'call') {
      const showData = line.contact.map(contact => `${contact.name} - ${contact.value}`).join('<br>');
      this.utils.showAlertOnlyButtonOk('Contactos', '', showData);
    }
    if (data.action === 'location') {
      console.log('location');
      const showData = line.address.map(address => `${address.name} - ${address.value}`).join('<br>');
      this.utils.showAlertOnlyButtonOk('Direcciones', '', showData);
    }
  }
  

  async deleteItem(itemId, itemDBId) {
    const alert = await this.alert.create({
      header: '¿Borrar?',
      message: 'Borrar cliente con id: ' + itemId,
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Sí',
          handler: async () => {
            // console.log('Item to remove!!!');
            // this.rest.deleteClient();
            await this.deleteClient(itemDBId);
          }
        }
      ]
    });
    await alert.present();
  }

  async deleteClient(clientId: string) {
    try {
      const resp: any = await this.rest.deleteClient(clientId);
      console.log(resp);
      if (resp.ok) {
        await this.utils.showToast('Cliente eliminado con éxito', 'success');
        setTimeout(
          () => location.reload()
          , 500);
      }
    } catch (error) {
      console.log(error);
      await this.utils.showToast('Error eliminando cliente', 'danger');
    }
  }

  addNew() {
    this.router.navigateByUrl('/cliente/new');
  }
  pagination(event: any) {
    if ((this.currentPage + event >= 0) && (this.currentPage + event <= this.maxPage)) {
      this.currentPage += event;
    }
    console.log(this.currentPage);
    if (!this.searchMode) {
      this.getClients();
    } else {
      this.search();
    }
  }

}
